/**
 * Safely gets a nested property from an object using a string path.
 * Example: getNestedValue(obj, "input_group.code")
 */
function getNestedValue(obj: Record<string, any>, path: string): any {
  return path.split('.').reduce((value, key) => {
    return value && value[key] !== undefined ? value[key] : undefined;
  }, obj);
}

/**
 * Groups an array of objects by a (possibly nested) field path.
 * Example: groupByField(data, "input_group.code")
 */
export function groupByField<T extends Record<string, any>>(
  array: T[],
  path: string,
): Record<string, T[]> {
  return array?.reduce<Record<string, T[]>>((acc, item) => {
    const key = getNestedValue(item, path);
    if (key === undefined || key === null) return acc;

    const groupKey = String(key);
    if (!acc[groupKey]) acc[groupKey] = [];
    acc[groupKey].push(item);

    return acc;
  }, {});
}
